import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Quote.scss';

const Quote = ({ content, attrs = {} }) => {
	if (!content) return null;
	const styles = {};
	if (attrs.align) styles.textAlign = attrs.align;
	if (attrs.textColor) styles.color = attrs.textColor;

	return (
		<blockquote className={s.quote} style={styles}>
			<p className={s.quote_content} dangerouslySetInnerHTML={{ __html: purifier(content.quote.rawText, { ADD_ATTR: ['target'] }) }} />
			{ content.cite && <cite className={s.quote_cite} dangerouslySetInnerHTML={{ __html: purifier(content.cite.rawText, { ADD_ATTR: ['target'] }) }} /> }
		</blockquote>
	);
};

export default hot(module)(Quote);
